export default __webpack_public_path__ + "static/media/759.6efec0d0.gif";